import { React, useEffect, useState, useContext } from "react";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import {
  JobCreate,
  JobTable,
  JobOverview,
  Multiselect,
  EnhancedAutocomplete,
  LocationAutocomplete,
} from "..";
import { UserContext } from "../../App";
import { FormGroup, FormControlLabel, Switch } from "@mui/material";
import "@geoapify/geocoder-autocomplete/styles/minimal.css";
import "../../styles/JobSearch.css";

function JobSearch() {
  const { userType, username } = useContext(UserContext);

  const [draft, setDraft] = useState(false);
  const [showInactive, setShowInactive] = useState(false);
  const [favorite, setFavorite] = useState(false);
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");

  const [jobLevel, setJobLevel] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [jobIndustry, setJobIndustry] = useState([]);

  const [skills, setSkills] = useState([]);
  const [companyNames, setCompanyNames] = useState([]);

  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState({});

  const [availableCompanies, setAvailableCompanies] = useState([]);
  const [availableSkills, setAvailableSkills] = useState([]);
  const [availableJobLevels, setAvailableJobLevels] = useState([]);
  const [availableJobTypes, setAvailableJobTypes] = useState([]);
  const [availableIndustries, setAvailableIndustries] = useState([]);

  const [updateFavorites, setUpdateFavorites] = useState(false);
  const [updateOffset, setUpdateOffset] = useState(false);

  const [updateTable, setUpdateTableHook] = useState(false);
  const [editedTable, setEditedTable] = useState(false);
  const [jobOffset, setJobOffset] = useState(0);
  const [handleChange, setHandleChange] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const setUpdateTable = (value) => {
    setUpdateTableHook(value);
    setSelectedJob({});
  };

  const handleSelectedJob = (job) => {
    if (userType === "student") {
      const body = new FormData();
      body.append("jobId", job.jobId);
      axios.post("/company/incrementViews", body).then((res) => {
      });
    }
    setSelectedJob(job);
  };

  const handleAppliedJob = (job) => {
    if (userType === "student") {
      const body = new FormData();
      body.append("jobId", job.jobId);
      axios.post("/company/incrementApplications", body).then((res) => {
      });
    }
  };

  const showSearchResults = () => {
    const body = new FormData();
    body.append("pid", username);
    body.append("title", title);
    body.append("location", location);
    body.append("jobType", jobType);
    body.append("jobLevel", jobLevel);
    body.append("jobIndustry", jobIndustry);
    body.append("skills", skills);
    body.append("userType", userType);
    body.append(
        "companyNames",
      userType === "company" ? [username] : companyNames,
    );
    body.append("draft", draft);
    body.append("active", showInactive == false);
    body.append("favorite", favorite);

    axios.post("/company/searchJobs", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setJobs(data.jobs);

        if (jobOffset == 0) {
          setSelectedJob(data.jobs[0]);
        }
        else {
          setSelectedJob(data.jobs.filter(job => job.jobId == jobOffset)[0]);
        }
      } 
      else {
      }
    });
  };

  // To only update the jobs, not unselecting job and not going back to page 1
  useEffect(() => {
    showSearchResults();
  }, [updateFavorites]);

  // To only update the jobs and unselect job, not going back to page 1
  useEffect(() => {
    showSearchResults();
  }, [editedTable]);

  // To update the jobs, unselect job, and go back to page 1
  useEffect(() => {
    setUpdateOffset(!updateOffset);
    setJobOffset(0);
    setHandleChange(false);
    setCurrentPage(0);
    showSearchResults();
  }, [
    title,
    location,
    jobLevel,
    jobType,
    jobIndustry,
    skills,
    companyNames,
    draft,
    showInactive,
    favorite,
    updateTable,
  ]);

  useEffect(() => {
    if (userType !== "company") {
      axios.get("/company/companies").then((res) => {
        const data = res.data;
        if (data.success) {
          setAvailableCompanies(data.companies);
        } else {
          return setAvailableCompanies([]);
        }
      });
    }
  }, [updateTable]);

  useEffect(() => {
    axios.get("/company/skills").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableSkills(data.skills);
      } else {
        return setAvailableSkills([]);
      }
    });
  }, []);

  //THESE sets of VALUES ARE HARDCODED BY THE TEAM BEFORE, if you want these to be tags, you
  //will have to emulate how it is done in researchPosition
  const jobLevelData = {
    label: "Job Levels",
    options: ["Internship", "Co-op", "Full-Time", "Part-Time"],
    value: jobLevel,
    setter: setJobLevel,
  };

  const jobTypeData = {
    label: "Job Types",
    options: ["In Person", "Remote", "Hybrid"],
    value: jobType,
    setter: setJobType,
  };

  const industryData = {
    label: "Industries",
    options: [
      "Software Development",
      "Software Engineering",
      "Project Management",
      "Other",
    ],
    value: jobIndustry,
    setter: setJobIndustry,
  };

  const resetHooks = () => {
    setTitle("");
    setLocation("");
    if (userType === "company") {
      setCompanyNames([username]);
    } else {
      setCompanyNames([]);
    }
    setJobLevel([]);
    setJobType([]);
    setJobIndustry([]);
    setSkills([]);
    setDraft(false);
    setFavorite(false);
    setShowInactive(false);
  };

  useEffect(() => {
    showSearchResults();
  }, [jobOffset]);

  return (
    <div className="JobSearch bg-brand-tertiary">
      <div className="JobSearch-container flex flex-col p-8 ">
        <div className="JobSearch-topContainer flex flex-wrap">
          <div className="JobSearch-searchBar flex search-button h-11 mr-4 w-60 mb-4">
            <input
              type="text"
              className="font-brand-quaternary h-full rounded-full ml-4 w-full"
              placeholder="Search"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <div className="my-auto mx-2">
              <SearchIcon size={16} />
            </div>
          </div>

          <LocationAutocomplete
            idAndClassName="JobSearch-LocationSearch"
            locationValue={location}
            setLocationValue={setLocation}
            key={100}
          />

          {/*showSearchDropdowns()*/}
          <EnhancedAutocomplete
            label="Job Levels"
            placeholder="Job Levels"
            options={jobLevelData.options}
            selectedValue={jobLevel}
            selectedSetter={setJobLevel}
            isMultiSelect={true}
          />
          <EnhancedAutocomplete
            label="Position Types"
            placeholder="Position Types"
            options={jobTypeData.options}
            selectedValue={jobType}
            selectedSetter={setJobType}
            isMultiSelect={true}
          />
          <EnhancedAutocomplete
            label="Industries"
            placeholder="Industries"
            options={industryData.options}
            selectedValue={jobIndustry}
            selectedSetter={setJobIndustry}
            isMultiSelect={true}
          />
          {userType === "company" ? null : (
            <EnhancedAutocomplete
              label="Companies"
              placeholder="Companies"
              options={availableCompanies}
              selectedValue={companyNames}
              selectedSetter={setCompanyNames}
              isMultiSelect={true}
            />
          )}
          <EnhancedAutocomplete
            label="Skills"
            placeholder="Skills"
            options={availableSkills}
            selectedValue={skills}
            selectedSetter={setSkills}
            isMultiSelect={true}
          />

          {userType === "student" && (
            <FormGroup
              sx={{
                bgcolor: "white",
                borderRadius: 4,
                height: 44,
                mb: 2,
              }}
              className="search-button mr-4"
            >
              <FormControlLabel
                control={<Switch checked={favorite} />}
                label="Favorites"
                onChange={(event, checked) => setFavorite(checked)}
                className="flex justify-center items-center mx-3"
              />
            </FormGroup>
          )}

          {(userType === "company" || userType === "admin") && (
            <FormGroup
              sx={{
                bgcolor: "white",
                borderRadius: 4,
                height: 44,
                mb: 2,
              }}
              className="search-button mr-4"
            >
              <FormControlLabel
                control={<Switch checked={showInactive} />}
                label="Show Inactive Jobs"
                onChange={(event, checked) => setShowInactive(checked)}
                className="flex justify-center mx-4"
              />
            </FormGroup>
          )}

          {(userType === "company" || userType === "admin") && (
            <FormGroup
              sx={{
                bgcolor: "white",
                borderRadius: 4,
                height: 44,
                mb: 2,
              }}
              className="search-button mr-4"
            >
              <FormControlLabel
                control={<Switch checked={draft} />}
                label="Drafts"
                onChange={(event, checked) => setDraft(checked)}
                className="flex justify-center mx-4"
              />
            </FormGroup>
          )}

          {(userType === "company" || userType === "admin") && (
            <JobCreate
              userType={userType}
              username={username}
              updateTable={updateTable}
              setUpdateTable={setUpdateTable}
            />
          )}
          <button
            type="button"
            className="search-button px-4 h-11 mb-4 text-center py-2 bg-blue"
            onClick={resetHooks}
          >
            Reset Search
          </button>
        </div>
        <div className="JobSearch-bottomContainer flex h-full">
          <div className="JobSearch-leftContainer">
            <JobTable
              jobs={jobs}
              selectedJob={selectedJob}
              setJob={handleSelectedJob}
              userType={userType}
              username={username}
              updateFavorites={updateFavorites}
              setUpdateFavorites={setUpdateFavorites}
              updateTable={updateTable}
              setUpdateTable={setUpdateTable}
              updateOffset={updateOffset}
              editedTable={editedTable}
              setEditedTable={setEditedTable}
              setJobOffset={setJobOffset}
              handleChange={handleChange}
              setHandleChange={setHandleChange}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
            />
          </div>
          <div className="JobSearch-rightContainer">
            <div>
              <JobOverview job={selectedJob} onJobApplied={handleAppliedJob} userType={userType} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default JobSearch;
